import styled from 'styled-components'

export const WelcomeStepWrapper = styled.div`
  .container-text {
    margin-top: 35px;
    box-sizing: border-box;
    border: 1px solid rgba(15, 87, 13, 0.1);
    border-radius: 5px;
    background: rgba(182, 215, 180, 0.1);
    width: 914px;
  }

  p {
    padding: 30px 15px;
    font-family: ${({ theme }) => theme.fonts.arial};
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0.4399999976158142px;
    text-align: left;

    strong {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
      font-size: 22px;
    }
  }

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 392px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 10px;
    display: block;
    margin: 0 auto;
    margin-top: 120px;
  }
`
